import React from "react";
import Table from "react-bootstrap/Table";

const StudentTable = ({ students }) => {
  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr className="text-light" style={{ backgroundColor: "#B8529E" }}>
            {/* <th>User ID</th> */}
            <th>First Name</th>
            <th>Last Name</th>
            {/* <th>Email</th> */}
            <th>Date Enrolled</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          {students.map((student, index) => (
            <tr key={index}>
              {/* <td>{student.user.user_id}</td> */}
              <td>{student.user.first_name}</td>
              <td>{student.user.last_name}</td>
              {/* <td>{student.user.email}</td> */}
            <td>{new Date(student.date_enrolled).toLocaleDateString()}</td>
              <td>{student.progress}%</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default StudentTable;
